export const NAVIGATION = {
  SET_USER_MENU: "SET_USER_MENU",
  SET_USER_MENU_OPEN: "SET_USER_MENU_OPEN",
  SET_USER_MENU_CLOSE: "SET_USER_MENU_CLOSE"
};
